import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';

class DownloadCenter {
  constructor() {

    this.inputs = document.querySelectorAll('.wp-downloadcenter-item__checkbox-input');
    this.filesize = document.querySelector('.js-dc-controls-filesize');
    this.button = document.querySelector('.js-dc-controls-zip');
    this.urls = [];

    if (this.inputs &&  this.button) {
      this.bindEvents();
    }
  }

  bindEvents(){
    this.inputs.forEach(input => {
      input.addEventListener('change', e => {
        this.reloadSize();
      });
    });

    this.button.addEventListener('click', e => {
      const zip = new JSZip();
      const urls = [];

      this.inputs.forEach(input => {
        if(input.checked){
          urls.push(input.getAttribute('data-url'));
        }
      });

      if (urls.length === 0) {
        return;
      }

      const zipFilename = 'dormakaba-downloads.zip';
      let count = 0;

      for (let i = 0; i < urls.length; i++) {
        const fileparts = urls[i].split('/');
        const filename = fileparts[fileparts.length - 1];
        JSZipUtils.getBinaryContent(urls[i], (err, data) => {
          if (err) {
            throw err;
          }
          zip.file(filename, this.urlToPromise(urls[i]), {binary: true});
          count++;
          if (count === urls.length) {
            zip.generateAsync({type: 'blob'}).then(function (content) {
              saveAs(content, zipFilename);
            });
          }
        });
      }
    });
  }

  reloadSize(){
    let size = 0;
    this.inputs.forEach(input => {
      if(input.checked){
        size = size + parseInt(input.getAttribute('data-size'));
      }
    });

    if (size === 0) {
      this.button.disabled = true;
    } else {
      this.button.disabled = false;
    }

    this.filesize.innerHTML = this.humanFilesize(size);
  }

  urlToPromise(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

	humanFilesize(bytes) {
		const size = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const factor = Math.floor((bytes.toString().length - 1) / 3);

		const newSize = Math.round(bytes / Math.pow(1024, factor));
		return `${newSize} ${size[factor]}`;
	}
}

export default DownloadCenter;
